import { townColorHex as hex } from './townPropTemplates';
import type { TownPropPalette } from './townPropTemplates';

/** A roofless 238×144 frontage: the real platform supplies the roof and all ledges. */
export function buildTrainerHallBody(p: TownPropPalette): string {
  const wall = hex(p.primary), shade = hex(p.shade), wood = hex(p.wood), edge = hex(p.woodEdge);
  const stone = hex(p.stone), iron = hex(p.iron), glass = hex(p.glass), light = hex(p.glassCore);
  const window = (x: number) => `
    <path d="M${x} 50V20Q${x + 12} 10 ${x + 24} 20V50Z" fill="${wood}" />
    <path d="M${x + 3} 47V22Q${x + 12} 15 ${x + 21} 22V47Z" fill="${glass}" opacity="0.72" />
    <path d="M${x + 12} 18V49 M${x + 2} 31H${x + 22}" stroke="${wood}" stroke-width="2" />
    <path d="M${x + 4} 46H${x + 20}" stroke="${light}" stroke-width="0.8" opacity="0.75" />
    <path d="M${x - 3} 53H${x + 27}" stroke="${edge}" stroke-width="1.5" />`;
  return `
    <g data-part="hall-wall">
      <rect x="0" y="0" width="238" height="144" fill="${wall}" />
      <rect x="0" y="0" width="238" height="12" fill="${shade}" />
      <rect x="0" y="66" width="238" height="65" fill="${shade}" />
      <path d="M3 12V132 M235 12V132 M71 9V132 M167 9V132 M1 64H237" fill="none" stroke="${wood}" stroke-width="5" />
      <path d="M6 13V128 M74 10V128 M170 10V128 M232 13V128 M7 66H230" fill="none" stroke="${edge}" stroke-width="0.8" opacity="0.55" />
      <path d="M7 13L67 57 M171 57L231 13 M7 71L67 125 M171 125L231 71" fill="none" stroke="${wood}" stroke-width="3" />
      <path d="M18 60H57 M181 60H220" stroke="${edge}" stroke-width="0.6" opacity="0.5" />
      ${window(24)} ${window(107)} ${window(190)}
    </g>
    <g data-part="hall-base">
      <rect x="0" y="131" width="238" height="13" fill="${stone}" />
      <path d="M0 137H238 M28 132V137 M58 137V144 M84 132V137 M154 132V137 M182 137V144 M210 132V137"
        fill="none" stroke="${iron}" stroke-width="0.8" opacity="0.7" />
      <path d="M93 144V87Q119 67 145 87V144Z" fill="${wood}" />
      <path d="M97 144V89Q119 73 141 89V144Z" fill="${iron}" />
      <path d="M100 142V91Q119 79 138 91V142Z" fill="${wood}" />
      <path d="M119 82V142 M106 91V140 M132 91V140" stroke="${edge}" stroke-width="0.8" opacity="0.55" />
      <path d="M103 105H115 M123 105H135 M103 128H115 M123 128H135" stroke="${iron}" stroke-width="2" />
      <circle cx="115" cy="117" r="1.4" fill="${edge}" /><circle cx="123" cy="117" r="1.4" fill="${edge}" />
    </g>`;
}
